import { BrandLoading } from "@ondit/ui";
import { useT } from "~/core/i18n";
import { Logo } from "~/shell/logo";

export function PageLoading({ fullPage = false }: { fullPage?: boolean }) {
	const t = useT();
	return (
		<BrandLoading label={t("state.loading")} slowLabel={t("state.loadingSlow")} fullPage={fullPage}>
			<Logo variant="mark" />
		</BrandLoading>
	);
}
